var jaJP = {
	"codeBlock.copied": "コピー済み",
	"codeBlock.copyLabel": "コピー",
	"inlineCodeBlock.copied": "コピー済み",
	"inlineCodeBlock.copyLabel": "インラインコードをコピー"
};

export { jaJP as default };
